/* Asian Food Mart: free-shipping progress and the per-order limit on heavy items.
   Settings come from window.afm, which layout/theme.liquid fills from the theme settings.
   Stock limits themselves are enforced by Shopify; this file only adds the heavy-item rule. */

(function () {
  var config = window.afm || {};
  var UNITS = { kg: 1000, g: 1, gm: 1, gram: 1, grams: 1, oz: 28.35, lb: 453.6, lbs: 453.6, ml: 1, l: 1000, liter: 1000, liters: 1000 };
  var SIZE = /(\d+(?:\.\d+)?)\s*(kg|grams?|gm|g|oz|lbs?|ml|liters?|l)\b/gi;

  // Product weights are not filled in on the store, so "heavy" is read from the pack size in the title
  function packSize(title) {
    var biggest = 0;
    var match;
    SIZE.lastIndex = 0;
    while ((match = SIZE.exec(title))) {
      biggest = Math.max(biggest, Number(match[1]) * UNITS[match[2].toLowerCase()]);
    }
    return biggest;
  }
  function isHeavy(title) {
    return packSize(title || '') >= config.heavySize;
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ---- Free-shipping progress (product page, cart drawer, cart page) ----
  function renderProgress(totalCents) {
    var threshold = config.freeShippingThreshold * 100;
    if (!threshold) return;
    document.querySelectorAll('[data-afm-progress]').forEach(function (el) {
      var text = el.querySelector('[data-afm-progress-text]');
      var bar = el.querySelector('[data-afm-progress-bar]');
      if (text) {
        text.textContent =
          totalCents >= threshold
            ? config.strings.unlocked
            : config.strings.remaining.replace('[amount]', money(threshold - totalCents));
      }
      if (bar) bar.style.width = Math.min(100, (totalCents / threshold) * 100) + '%';
    });
  }

  // ---- Heavy items: cap the quantity inputs ----
  function capInput(input, title) {
    if (!input || !isHeavy(title)) return false;
    var current = parseInt(input.max, 10);
    var limit = isNaN(current) ? config.heavyLimit : Math.min(current, config.heavyLimit);
    if (input.max !== String(limit)) {
      input.max = limit;
      input.dataset.max = limit;
    }
    return true;
  }
  function applyLimits() {
    // Cart page and cart drawer rows
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var name = row.querySelector('.cart-item__name');
      capInput(row.querySelector('.quantity__input'), name ? name.textContent : '');
    });
    // Product page
    document.querySelectorAll('product-info').forEach(function (info) {
      var title = info.querySelector('.product__title');
      var input = info.querySelector('.quantity__input');
      var heavy = capInput(input, (title ? title.textContent : '') + (config.productIsHeavy ? ' 9999g' : ''));
      if (heavy && input && !info.querySelector('.afm-limit-note')) {
        var note = document.createElement('p');
        note.className = 'afm-limit-note';
        note.textContent = config.strings.heavyNote;
        var holder = input.closest('.product-form__quantity') || input.parentElement;
        holder.appendChild(note);
      }
    });
  }

  // ---- Heavy items: if a quick add pushed a line past the limit, bring it back down ----
  var fixing = false;
  function enforceCart(cart) {
    var over = cart.items.filter(function (item) {
      return isHeavy(item.product_title) && item.quantity > config.heavyLimit;
    });
    if (!over.length || fixing) return;
    fixing = true;
    var updates = {};
    over.forEach(function (item) {
      updates[item.key] = config.heavyLimit;
    });
    fetch(config.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (fixed) {
        renderProgress(fixed.total_price);
        if (document.querySelector('cart-items:not(cart-drawer-items)')) {
          window.location.reload();
          return;
        }
        return refreshDrawer().then(function () {
          window.alert(config.strings.heavyNote);
        });
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        fixing = false;
      });
  }
  function refreshDrawer() {
    return fetch(config.routes.cart + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
          var current = document.querySelector(selector);
          var fresh = doc.querySelector(selector);
          if (current && fresh) current.replaceWith(fresh);
        });
      });
  }

  function onCartChange() {
    fetch(config.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderProgress(cart.total_price);
        enforceCart(cart);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  // ---- Scroll progress line ----
  function initScrollProgress() {
    var bar = document.querySelector('.afm-scroll-progress span');
    if (!bar) return;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (max > 0 ? (window.scrollY / max) * 100 : 0) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ---- Header progress pill: open the cart drawer when there is one, otherwise follow the link ----
  function initCartOpeners() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-afm-open-cart]');
      var bubble = document.getElementById('cart-icon-bubble');
      if (!opener || !bubble || !document.querySelector('cart-drawer')) return;
      event.preventDefault();
      bubble.click();
    });
  }

  function init() {
    applyLimits();
    initScrollProgress();
    initCartOpeners();
    // The cart drawer and cart page redraw their rows after every change, so re-apply the caps
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.setTimeout(function () {
        queued = false;
        applyLimits();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });

    // subscribe and PUB_SUB_EVENTS come from the theme's pubsub.js and constants.js
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
